import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { API_SERVICE_BASE_PATH } from "../../services/fetch";
import { TOKEN_COOKIE_NAME } from "../../contexts/auth";
import Cookies from "js-cookie";

const httpLink = new HttpLink({
  uri: API_SERVICE_BASE_PATH + "graphql",
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = Cookies.get(TOKEN_COOKIE_NAME);

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default {
  client,
};
